export type ItemListSummaryRow = {
  itemCode: string
  itemName: string
  category: string
  location: string
  uom: string
  soh: number
  avgCost: number
  lastPrice: number
  sellingPrice: number
  stockStatus: string
  movementStatus: string
}

export type RangeMode = "month" | "quarter" | "year" | "custom"

export type ListItemSummaryFilter = {
  rangeMode: RangeMode
  /** YYYY-MM untuk input month */
  periodMonth: string
  location: string
  category: string
  stockStatus: string
  valueRange: string
  movement: string
  supplier: string
  search: string
}

export type SortKey =
  | "code"
  | "name"
  | "category"
  | "location"
  | "soh"
  | "avgCost"
  | "lastPrice"
  | "sellingPrice"
  | "inventoryValue"
  | "margin"
  | "stockStatus"
  | "movementStatus"

export type SortState = {
  key: SortKey
  asc: boolean
}

export type ExportOutputType = "xls" | "pdf" | "print"

export const RANGE_MODE_OPTIONS = [
  { value: "month", label: "Month" },
  { value: "quarter", label: "Quarter" },
  { value: "year", label: "Year" },
  { value: "custom", label: "Custom Date" }
] as const

export const LOCATION_OPTIONS = [
  { value: "All Locations", label: "All Locations" },
  { value: "Main Warehouse", label: "Main Warehouse" },
  { value: "Retail Store", label: "Retail Store" },
  { value: "Project Site", label: "Project Site" },
  { value: "Resort Store", label: "Resort Store" },
  { value: "Production", label: "Production" }
]

export const CATEGORY_OPTIONS = [
  { value: "All Categories", label: "All Categories" },
  { value: "Finished Goods", label: "Finished Goods" },
  { value: "RM - Fabric", label: "RM - Fabric" },
  { value: "SRV - Sewing", label: "SRV - Sewing" },
  { value: "Hamman", label: "Hamman" },
  { value: "Cushion Cover", label: "Cushion Cover" },
  { value: "Amenities", label: "Amenities" },
  { value: "Food & Beverage", label: "Food & Beverage" },
  { value: "Project Material", label: "Project Material" },
  { value: "Spare Parts", label: "Spare Parts" },
  { value: "Consumables", label: "Consumables" },
  { value: "Retail Product", label: "Retail Product" }
]

export const STOCK_STATUS_OPTIONS = [
  { value: "All", label: "All" },
  { value: "In Stock", label: "In Stock" },
  { value: "Low Stock", label: "Low Stock" },
  { value: "Out of Stock", label: "Out of Stock" },
  { value: "Overstock", label: "Overstock" },
  { value: "Dead Stock", label: "Dead Stock" },
  { value: "Negative Stock", label: "Negative Stock" }
]

export const VALUE_RANGE_OPTIONS = [
  { value: "All", label: "All" },
  { value: "High Value Items", label: "High Value Items" },
  { value: "Medium Value Items", label: "Medium Value Items" },
  { value: "Low Value Items", label: "Low Value Items" }
]

export const MOVEMENT_OPTIONS = [
  { value: "All", label: "All" },
  { value: "Fast Moving", label: "Fast Moving" },
  { value: "Normal Moving", label: "Normal Moving" },
  { value: "Slow Moving", label: "Slow Moving" },
  { value: "No Movement", label: "No Movement" }
]

export const SUPPLIER_OPTIONS = [
  { value: "All Suppliers", label: "All Suppliers" },
  { value: "CV Sumba Textile", label: "CV Sumba Textile" },
  { value: "PT Bali Living", label: "PT Bali Living" },
  { value: "UD Nusantara Craft", label: "UD Nusantara Craft" },
  { value: "Global Linen Supply", label: "Global Linen Supply" }
]

export const DEFAULT_FILTER: ListItemSummaryFilter = {
  rangeMode: "month",
  periodMonth: "2026-05",
  location: "All Locations",
  category: "All Categories",
  stockStatus: "All",
  valueRange: "All",
  movement: "All",
  supplier: "All Suppliers",
  search: ""
}
